/* src/app/components/admin/employee-role/employee-role.component.scss */
.employee-search mat-form-field {
  height: 48px;
}
mat-form-field.custom-infix-padding {
  --padding-top: 22px;
  --padding-bottom: 8px;
}
.row {
  padding-bottom: 15px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.list {
  height: 340px;
  overflow: auto;
  border: 1px solid #949494;
  border-radius: 4px;
}
:host-context(.dark-theme) .list {
  border: 1px solid #656565;
}
/*# sourceMappingURL=employee-role.component.css.map */
